'use strict'
export default class experiences {
    constructor(
        name = "",
        description = "",
        name_company = ""
    ) {
        this.name = name
        this.description = description
        this.name_company = name_company
    }

}